import React from 'react';
import PropTypes from 'prop-types';

import FilterItem from './FilterItem';

import { FACET_ELEMENTS } from '../../../../../constants/seatingChartConstants';

const FilterSection = ({
  activeBucketSets,
  activeFacetElements,
  elements,
  facetCounts,
  label,
  onToggleFacet,
}) => {
  return (
    <div className="sc__filter__facet">
      <div className="sc__filter__label">{label}</div>
      <ul className="list-unstyled sc__filter__list">
        {elements.length > 0 &&
          elements.map(element => {
            const { name } = FACET_ELEMENTS[element];
            return (
              <FilterItem
                key={name}
                activeFacetElements={activeFacetElements}
                activeBucketSets={activeBucketSets}
                checked={activeFacetElements.indexOf(element) > -1}
                currentBucket={label}
                element={element}
                facetCount={facetCounts[element]}
                label={label}
                name={name}
                onChange={() => onToggleFacet(element)}
              />
            );
          })}
      </ul>
    </div>
  );
};

FilterSection.propTypes = {
  activeBucketSets: PropTypes.objectOf(PropTypes.array),
  elements: PropTypes.arrayOf(PropTypes.string),
  facetCounts: PropTypes.objectOf(PropTypes.number),
  label: PropTypes.string,
  onToggleFacet: PropTypes.func,
};

export default FilterSection;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/GuestList/Filter/FilterSection.jsx